import React from 'react';
import { t } from 'i18next';
import Table from 'components/Table';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { isExpired, moneyDecimalFormatter, customRound } from 'utli';
import { Button } from 'reactstrap';

function List({
  headers,
  data,
  title,
  subtitle,
  buttons,
  filter,
  onPageChange,
  onInvoiceClick,
  onChoose,
  canPay,
  onPay,
  onPrint,
}) {
  return (
    <div>
      <Table
        data={data}
        title={title}
        subtitle={subtitle}
        filter={filter}
        onPageChange={onPageChange}
        headers={headers.map((e) => (
          <th
            className={clsx('headers', e.className)}
            key={`thead-${Math.random()}`}
            style={{ width: e.width, left: e.left }}
          >
            {t(e.text)}
          </th>
        ))}
        buttons={buttons}
        rows={data?.docs?.map((e, index) => (
          <tr key={`table-row-${index}-${Math.random()}`} className={clsx(isExpired(e.expire_date) && 'deactive')}>
            <td className='fixed-cell left'>
              <span onClick={() => onInvoiceClick(e)} style={{ cursor: 'pointer' }}>
                {e.invoice_number}
              </span>
            </td>
            <td>{e.ref_no || '-'}</td>
            <td>{e.license_no || '-'}</td>
            <td>{e.invoice_date ? dayjs(e.invoice_date).format('DD/MM/YYYY') : '-'}</td>
            <td>{e.address_code || '-'}</td>
            <td>{e.sender?.name || '-'}</td>
            <td>{e.sender?.phone || '-'}</td>
            <td>{e.destination?.name || '-'}</td>
            <td>{e.sale_person?.name || '-'}</td>
            <td>{e.paymentType?.name || '-'}</td>
            <td>{e.currency || 'USD'}</td>
            <td style={{ textAlign: 'right' }}>
              {moneyDecimalFormatter(customRound(e.total_amount?.toFixed(2)))}
            </td>
            <td style={{ textAlign: 'right' }}>
              {moneyDecimalFormatter(customRound(e.other_service_charges?.toFixed(2)))}
            </td>
            <td style={{ textAlign: 'right' }}>
              {moneyDecimalFormatter(customRound(e.received_amount?.toFixed(2)))}
            </td>
            <td style={{ textAlign: 'right' }}>
              {moneyDecimalFormatter(customRound(e.remaining_balance?.toFixed(2)))}
            </td>
            <td>{e.deposit_invoice?.invoice_number || '-'}</td>

            {!onChoose && (
              <td className='fixed-cell px-2'>
                <Button
                  style={{ width: 30 }}
                  size='sm'
                  onClick={() => onPay(e)}
                  disabled={!(e.remaining_balance > 0 && canPay())}
                >
                  <i className='fa fa-plus mr-2' />
                </Button>
                <Button
                  style={{ width: 30 }}
                  size='sm'
                  onClick={() => {
                    onInvoiceClick(e);
                  }}
                >
                  <i className='fa fa-eye mr-2' />
                </Button>
                <Button
                  style={{ width: 30 }}
                  size='sm'
                  onClick={() => {
                    onPrint(e);
                  }}
                >
                  <i className='fa fa-file-archive mr-2' />
                </Button>
              </td>
            )}
          </tr>
        ))}
      />
    </div>
  );
}

export default List;
